import {Component, EventEmitter, Input} from '@angular/core';
import {IconFont} from "../../enums/icon-font";

@Component({
  selector: 'brt-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent {
  @Input('icon') icon!: IconFont;
  @Input('add-blur') addBlur: boolean = false;
}
